/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：员工所需接口地址
 */
// 获取员工角色列表
export const roleList = '/account/account-list/get-all-roles'
export const allPrivilege = '/account/account-list/all-privilege'
// 用户角色权限 end
// 员工列表页面 start
// 获取员工列表
export const employeeList = '/account/account-list/list'
// 获取员工信息
export const employeeInfo = '/account/account-list/get-member-info'
// 保存员工
export const saveEmployee = '/account/account-list/save'
// 删除员工
export const delEmployee = '/account/account-list/del-member'
// 锁定或解锁子帐号
export const lockEmployee = '/account/account-list/lock'
// 获取员工业绩列表
export const employeePerformance = '/account/account-list/employee-performance'
// 微信绑定解绑
export const saveBind = '/account/account-list/save-bind-info'
// 员工列表页面 end
// 用户权限
export const userPrivilege = '/account/account-list/user-privilege'



// WEBPACK FOOTER //
// ./src/api/url/employee.js